import Cookies from 'js-cookie'

const port = window.location.port
const TokenKey = 'vue_sportsaas_token_'+port

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setRemember(key,val) {
  return Cookies.set(key, val)
}

export function getRemember(key) {
  return Cookies.set(key)
}

export function removeRemember(key,val) {
  return Cookies.set(key)
}
